import { DialogActions, styled } from '@mui/material';

export const ModalFooter = styled(DialogActions)({
  gap: '0.5rem',
});
